import { Facet, Event, getTagTypeName, isMatchingLocation } from '../../FilterList/scripts/product-facets';
import { isEmptyFilterValue, getProductValue } from '../../FilterList/scripts/filter-utils';
import '../../FilterList/scripts/view';
import {maybeUpdateTimezones} from "../../../utils";

( function( $ ) {
	'use strict';

	$(document).ready(function() {

		const $listings = $( '[data-module="listing"]' );

		window.colibri.activeFilters = window.colibri.activeFilters || {};

		const itemsWithCards = new Set();

		if ( !$listings.length ) {
			//nothing to do here
			return;
		}

		setTimeout( initListings, 1 ); //do this in a separate thread

		function reindexCards() {
			itemsWithCards.clear();

			$listings.find( '.card' ).each( ( listIdx, card ) => {
				itemsWithCards.add( + card.getAttribute( 'data-item-id' ) );
			} );
		}

		function initListings () {

			reindexCards();

			$listings.each( ( index, listing ) => {

				const $listing = $( listing );
				const listingId = $listing.data('id');
				const $filterList = $listing.find( '.filter-list' ).first();
				const $productLists = $listing.find( '.product-list-container' );

				/**
				 * update card counter
				 */
				$productLists.each( ( plindex, pl ) => {
					const $productList = $( pl );
					$productList.find( '.count-results span' ).text( $productList.find( '.card' ).length );
				} );

				/**
				 * Reindex cards and let Filters panel to hide options that do not apply to current result set
				 */
				$listing.bind( Event.REQUEST_REINDEX, ( event, data ) => {
					reindexCards();
					$( event.target ).trigger( Event.ITEMS_CHANGED, [{
						activeFilters: window.colibri.activeFilters[listingId]
					}] );
				} );

				/**
				 * Run maybeUpdateTimezones to update the times on live course cards to reflect local timezones.
				 */
				$listing.bind( Event.UPDATE_TIMEZONES, ( event, data ) => {
					maybeUpdateTimezones();
				} );

				/**
				 * Apply current filters
				 */
				$filterList.bind( Event.FILTER_CHANGED, ( event, filters ) => {

					window.colibri.activeFilters = window.colibri.activeFilters || {};

					/**
					 * Collect all active filters
					 */
					if ( typeof filters[ 'reset-filters' ] !== 'undefined' ) {

						/**
						 * Special case: resetting all filters.
						 */
						window.colibri.activeFilters[listingId] = {};

					} else if ( Object.entries( filters ).length > 1 ) {

						/**
						 * collect and normalize filter values
						 */
						if (
							Object.entries( filters ).length === 2
							&& typeof filters[ Facet.search_phrase ] !== 'undefined'
							&& filters[ Facet.search_phrase ] === null
						) {
							/**
							 * special case -- removing search phrase
							 */
							window.colibri.activeFilters = window.colibri.activeFilters || {};
							window.colibri.activeFilters[listingId] = window.colibri.activeFilters[listingId] || {};
							delete window.colibri.activeFilters[listingId][ Facet.search_phrase ];
							delete window.colibri.activeFilters[listingId][ Facet.search_phrase_item_ids ];
						} else if (
							/**
							 * special case -- setting search phrase with ids of matching products
							 */
							Object.entries( filters ).length === 2
							&& typeof filters[ Facet.search_phrase ] !== 'undefined'
							&& typeof filters[ Facet.search_phrase_item_ids ] !== 'undefined'
						) {
							window.colibri.activeFilters = window.colibri.activeFilters || {};
							window.colibri.activeFilters[listingId] = window.colibri.activeFilters[listingId] || {};
							window.colibri.activeFilters[listingId][ Facet.search_phrase ] = filters[ Facet.search_phrase ];
							window.colibri.activeFilters[listingId][ Facet.search_phrase_item_ids ] = filters[ Facet.search_phrase_item_ids ];
						} else {
							/**
							 * if multiple filters are provided, then replace all existing filters with the new ones
							 */
							window.colibri.activeFilters[listingId] = filters
						}

					} else {

						window.colibri.activeFilters = window.colibri.activeFilters || {};
						window.colibri.activeFilters[listingId] = window.colibri.activeFilters[listingId] || {};

						/**
						 * if only one value provided, assign it to the current filter
						 */
						Object.entries( filters ).forEach( ( [facetName, filterValues] ) => {
							window.colibri.activeFilters[listingId][ facetName ] = filterValues;
						} )

					}

					/**
					 * shorthand variable
					 */
					const activeFilters = window.colibri.activeFilters[listingId];

					/**
					 * Filters changed -- re-select qualifying items across all product lists
					 */
					let matchingItemIds = Object.keys( window.colibri.index.products ).map( pid => +pid ).filter( pid => itemsWithCards.has( pid ) );

					Object.entries( activeFilters ).forEach( ( [facetName, filterValues] ) => {

						if ( !matchingItemIds.length ) {
							return false; //break;
						}

						if ( isEmptyFilterValue( filterValues ) ) {
							return true; //continue;
						}

						/**
						 * range-based facets
						 */
						switch ( facetName ) {
							case Facet.primary_hours:
							case Facet.secondary_hours:
							case Facet.price:
							case Facet.rating:
							case Facet.start_time:

								filterValues.min = parseFloat( filterValues.min );
								filterValues.max = parseFloat( filterValues.max );

								matchingItemIds = matchingItemIds.filter( pid => {

									let productValue = getProductValue( pid, facetName );

									if ( productValue && ( facetName === Facet.primary_hours || facetName === Facet.secondary_hours ) ) {
										productValue = productValue[ 0 ];
									}

									if ( null === productValue ) {
										return filterValues.min === 0; //if filter min is zero, permit null values
									}

									return productValue >= filterValues.min && productValue <= filterValues.max
								} );
								break;
							case Facet.location:
								matchingItemIds = matchingItemIds.filter( pid => {
									return isMatchingLocation( window.colibri.index.products[ pid ], filterValues );
								} );
								break;
							case Facet.search_phrase:
								if ( typeof activeFilters[ Facet.search_phrase_item_ids ] !== 'undefined' ) {
									if ( activeFilters[ Facet.search_phrase_item_ids ].length ) {
										const productIds = activeFilters[ Facet.search_phrase_item_ids ].map( v => parseInt( v ) );
										matchingItemIds = matchingItemIds.filter( pid => productIds.indexOf( pid ) > - 1 );
									} else {
										matchingItemIds = [];
									}
								}
								break;
						}
					} );

					/**
					 * Collect item ids of products that match the current filtering criteria
					 */
					const prefilteredItemIds = matchingItemIds;

					Object.entries( activeFilters ).forEach( ( [facetName, filterValues] ) => {

						if ( !matchingItemIds.length ) {
							return false; //break
						}

						if ( isEmptyFilterValue( filterValues ) ) {
							return true; //continue
						}

						switch ( facetName ) {
							case Facet.credit_type:
							case Facet.profession_id:
							case Facet.license_type_id:
							case Facet.state_code:
							case Facet.education_type_id:
							case Facet.delivery_method_id:
							case Facet.license_levels:
							case Facet.authors:
							case Facet.instructors:
							case Facet.is_partnership_group_item_required:
							case Facet.tags + '::' + getTagTypeName( facetName ):
								/**
								 * intersect the sets of product ids
								 */
								const facetIds = window.colibri.index.facets[ facetName ];
								matchingItemIds = matchingItemIds.filter( pid => filterValues.some( val => ( val in facetIds ) && facetIds[ val ].includes( pid ) ) );
								if ( !matchingItemIds.length ) {
									return false;
								}
								break;
						}

					} );

					const matchingProductsSet = new Set( matchingItemIds );

					/**
					 * count non-empty filters
					 */
					let countFilters = 0;
					Object.entries( activeFilters ).forEach( ( [facetName, filterValues] ) => {
						if ( !isEmptyFilterValue( filterValues ) ) {
							countFilters ++;
						}
					} );

					/**
					 * Request all product lists to update their current view to reflect cards that match filters
					 */
					$productLists.each( ( listIdx, productList ) => {
						setTimeout( () => {
							/**
							 * spawn a separate thread to update DOM of each the course list
							 */
							$( productList ).trigger( Event.LIST_UPDATE, [{
								countFilters, matchingProductsSet
							}] );
						}, 1 );
					} );

					window.colibri.data.matchingItemIds = window.colibri.data.matchingItemIds || {};
					window.colibri.data.matchingItemIds[listingId] = matchingItemIds;
					window.colibri.data.prefilteredItemIds = window.colibri.data.prefilteredItemIds || {};
					window.colibri.data.prefilteredItemIds[listingId] = prefilteredItemIds;

					/**
					 * Maybe show No Results message
					 */
					const $noResults = $listing.children( '.no-results' );
					if ( !$noResults.next().is( '.product-list-container' ) ) {
						$noResults.insertBefore( $productLists.first() );
					}

					if ( matchingItemIds.length ) {
						$noResults.addClass( 'd-none' );
					} else {
						$noResults.removeClass( 'd-none' );
					}

					/**
					 * update Filter panel to hide options that do not apply to the current result set
					 */
					$listing.trigger( Event.ITEMS_CHANGED, [{
						activeFilters
					}] );

				} ); //bind to filter-change
			} )
		}

	}); //ready

} )( jQuery );
